<template>
  <div class="mt-5 mb-10">
    <section class="flex items-center justify-between">
      <p class="flex flex-col gap-y-1">
        <span class="font-medium text-xs lg:text-sm"
          >Utilize Intermediary Bank</span
        >
        <span class="font-light text-xs lg:text-sm"
          >Provide intermediary bank details</span
        >
      </p>
      <el-switch
        v-model="showIntermediaryBankDetailsForm"
        @change="switchHandler"
      />
    </section>
    <transition name="slide-fade" mode="out-in">
      <el-form
        v-if="showIntermediaryBankDetailsForm"
        label-position="top"
        :model="intermediaryBankDetailsForm"
        ref="intermediaryBankDetailsForm"
        :rules="rules"
        label-width="80px"
        size="normal"
      >
        <!-- bank name -->
        <el-form-item label="Bank Name" prop="bankName">
          <el-input
            class="w-full"
            v-model="intermediaryBankDetailsForm.bankName"
            placeholder="Enter Bank Name"
          />
        </el-form-item>
        <!-- form group -->
        <div class="grid lg:grid-cols-2 gap-2">
          <el-form-item label="Bank Reference" prop="reference">
            <el-input
              class="w-full"
              v-model="intermediaryBankDetailsForm.reference"
              placeholder="Enter Bank Reference"
            />
          </el-form-item>
          <el-form-item label="Swift Code/Routing Number" prop="swiftCode">
            <el-input
              class="w-full"
              v-model.trim="intermediaryBankDetailsForm.swiftCode"
              placeholder="Enter Swift Code/Routing Number"
            />
          </el-form-item>
        </div>
        <!-- bank address -->
        <el-form-item label="Bank Address" prop="bankAddress">
          <el-input
            class="w-full"
            v-model="intermediaryBankDetailsForm.bankAddress"
            placeholder="Enter Bank Address"
          />
        </el-form-item>
      </el-form>
    </transition>
  </div>
</template>

<script>
import { ValidateInput, ValidateSwiftCode } from '@/utils/helpers.js'
export default {
  components: {
    Transition: () =>
      import('@/components/v2/animation/transition/Transition.vue')
  },
  data () {
    return {
      showIntermediaryBankDetailsForm: false,
      intermediaryBankDetailsForm: {
        bankName: '',
        bankAddress: '',
        swiftCode: '',
        reference: ''
      },
      rules: {
        bankName: [
          {
            message: 'Please enter intermediary bank name',
            trigger: ['blur', 'change']
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        bankAddress: [
          {
            message: 'Please enter intermediary bank address',
            trigger: ['blur', 'change']
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ],
        swiftCode: [
          {
            required: true,
            message: 'Please enter intermediary bank swift code',
            trigger: ['blur', 'change']
          },
          { validator: ValidateSwiftCode, trigger: ['blur', 'change'] }
        ],
        reference: [
          {
            message: 'Please enter intermediary bank reference',
            trigger: ['blur', 'change']
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    validateFormHandler () {
      return (
        !this.showIntermediaryBankDetailsForm ||
        this.validateForm('intermediaryBankDetailsForm')
      )
    },
    validateForm (intermediaryBankDetailsForm) {
      let isValid = false
      this.$refs[intermediaryBankDetailsForm].validate((valid) => {
        if (valid) {
          this.$emit('form-details', this.intermediaryBankDetailsForm)
          isValid = true
        }
      })
      return isValid
    },
    switchHandler (val) {
      // reset fields
      if (!val) {
        this.intermediaryBankDetailsForm = {
          bankName: '',
          bankAddress: '',
          swiftCode: '',
          reference: ''
        }
      }
    }
  }
}
</script>

<style scoped>
>>> .el-switch.is-checked .el-switch__core {
  border-color: var(--color-primary);
  background-color: var(--color-primary);
}

.el-switch.is-checked .el-switch__core {
  border-color: var(--color-primary) !important;
  background-color: var(--color-primary) !important;
}
>>> .el-switch.is-disabled .el-switch__core {
  cursor: pointer;
}

.el-switch__core {
  background: var(--foreground-on-disabled);
  border-color: var(--foreground-on-disabled);
  width: 48px;
  border-radius: 24px;
  /* height: 21.5px; */
}

>>> .el-switch.is-checked .el-switch__core {
  background: var(--color-primary);
  border-color: var(--color-primary);
}

>>> .el-switch__core:after {
  width: 20px;
  height: 20px;
}

>>> .el-switch.is-checked .el-switch__core::after {
  margin-left: -20px;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
